import {
  Box,
  VStack,
  Text,
  useMediaQuery,
  Skeleton,
  useColorModeValue,
  Flex,
  Divider,
} from '@chakra-ui/react';
import NoDataBox from './NoDataBox';
import { useCreateTemplateAction } from '../pass-templates-new/hooks/useCreateTemplateAction';

const DashboardNoPassTemplates = ({ isLoading }) => {
  const [isSmallerThan770] = useMediaQuery('(max-width: 770px)');
  const modeSkeletonStartColor = useColorModeValue('#d8d8d8', '#000000');
  const modeSkeletonEndColor = useColorModeValue('#EFEFEF', '#515d66');
  const { createTemplateTo } = useCreateTemplateAction();

  return (
    <Box
      w="full"
      bg="white"
      borderRadius="12px"
      boxShadow="0px 3.5px 5.5px rgba(0, 0, 0, 0.02)"
      _before={{
        content: '""',
        position: 'absolute',
        inset: 0,
        padding: '1.5px',
        borderRadius: 'inherit',
        background: 'linear-gradient(180deg, #FF9554 16%, #FF4935 100%)',
        WebkitMask:
          'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
        WebkitMaskComposite: 'xor',
        maskComposite: 'exclude',
        pointerEvents: 'none',
      }}
      p={7}
      position="relative"
    >
      <VStack align="start" gap={'18px'} mb={isSmallerThan770 ? 0 : 3}>
        <Text textStyle="heading4">
          <Skeleton
            isLoaded={!isLoading}
            startColor={modeSkeletonStartColor}
            endColor={modeSkeletonEndColor}
          >
            Pass templates
          </Skeleton>
        </Text>
        <Flex justify="center" w="full" direction="column" gap={4}>
          <Divider
            border="0"
            height="1px"
            borderRadius="full"
            background="linear-gradient(90deg, #FF9554 16%, #FF4935 100%)"
          />{' '}
          <NoDataBox
            buttonText="Create pass template"
            buttonLink={createTemplateTo}
            opacity={1}
            buttonType="gradient"
            title="No templates yet"
            description="Create your first pass template to start designing passes. You'll need at least one template before you can issue any passes."
            fullWidth={true}
          />
        </Flex>
      </VStack>
    </Box>
  );
};

export default DashboardNoPassTemplates;
